import * as yup from 'yup';

export const DataPointPeriodicity = {
  month: 'month',
  quarter: 'quarter',
  year: 'year',
} as const;
export type DataPointPeriodicity = (typeof DataPointPeriodicity)[keyof typeof DataPointPeriodicity];

export const DataCollectionType = {
  kpi: 'kpi',
  document: 'document',
  cap_table: 'cap_table',
  other: 'other',
} as const;
export type DataCollectionType = (typeof DataCollectionType)[keyof typeof DataCollectionType];

// the response includes other statuses too, but we are not interested in them
export const CompanyPeriodRequestStatus = {
  draft: 'draft',
  sent: 'sent',
  responded: 'responded',
  submitted: 'submitted',
  processing: 'processing',
  accepted: 'accepted',
  rejected: 'rejected',
} as const;
export type CompanyPeriodRequestStatus =
  (typeof CompanyPeriodRequestStatus)[keyof typeof CompanyPeriodRequestStatus];

export function companyPeriodRequestFields() {
  return {
    id: yup.string().uuid().required(),
    dataType: yup.array().of(yup.string().oneOf(Object.values(DataCollectionType))),
    period: yup.string().required(), // yyyy-MM-dd
    periodicity: yup.string().oneOf(Object.values(DataPointPeriodicity)).required(),
    status: yup.string().oneOf(Object.values(CompanyPeriodRequestStatus)).required(),

    maggieCompanyId: yup.number().nullable(),
    maggieCompanyName: yup.string().nullable(), // we'll need this field if we need to show unmapped companies (for now it's only companies with maggieCompanyId)
    _unmapped: yup.boolean(),
    ////////////
    // respondentEmails: yup.array().of(yup.string()).required(),
    // secondaryEmails: yup.array().of(yup.string()).required(),
    // status: yup.string().oneOf(Object.values(CompanyPeriodRequestStatus)).required(),
    // rejectionNote: yup.string().nullable(),
    // sentAt: yup.date().nullable(),
    // dueDate: yup.date().nullable(),
    // submittedAt: yup.date().nullable(),
    // processingAt: yup.date().nullable(),
    // acceptedAt: yup.date().nullable(),
    // rejectedAt: yup.date().nullable(),
    // archivedAt: yup.date().nullable(),
    // createdAt: yup.date().required(),
    // updatedAt: yup.date().required(),
  };
}

export function companyPeriodRequestSchema() {
  return yup.object().shape(companyPeriodRequestFields());
}

export type CompanyPeriodRequest = yup.InferType<ReturnType<typeof companyPeriodRequestSchema>>;
